import React, { useEffect } from "react";
import { useState } from "react";
import { Button, Divider, Grid, useMediaQuery, Link } from "@mui/material";
import { Location } from "history";
import { ReactElement } from "react";
import { StaticContext } from "react-router";
import { Link as RouterLink, RouteComponentProps } from "react-router-dom";
import { useHistory } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import WhiteInosio from "../../icons/whiteinosio.svg";
import BMWHelvetica75 from "../../fonts/BMWHelvetica-Bold/BMWHelvetica-Bold.otf";
import { makeStyles } from "@mui/styles";
import { useDispatch, useSelector } from "react-redux";
import Box from "@mui/material/Box";
import { selectAuthState, getRefreshUser, getPasswordLogin, getAddProfile, clearCredentials } from "../../shared/sagas/auth/authSlice";
import { RightContainer } from "../../components/RightContainer";
import { getResidentDetails } from "../payments/sagas/residentpaymentsSlice";
import { AddProfileDto, Role } from "@inosio/payments-sdk";
import { EmailRegex } from "../../utils/regex";

type LocationState = {
  from: Location;
  token: any;
  addprofile: boolean;
  residentUuid?: string;//This is for new resident registraion flow
  email?: string;
};

const useStyles = makeStyles(() => ({
  rootContainer: {
    height: "100vh",
    width: "100%",
    display: "flex",
    flexDirection: "row",
    background: "#FFFFFF",
    borderRadius: "24px",
  },
  rightContainer: {
    background: "#053742",
    width: "59%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto",
  },
  leftContainer: {
    borderRadius: "24px 0px 0px 24px",
    background: "#FFFFFF",
    width: "41%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto",
  },
  brandContainer: {
    display: "flex",
    flexDirection: "row",
    marginBottom: "30px",
    width: "340px",
    marginLeft: "30px",
    padding: "20px",
  },
  brandtextContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    marginLeft: "36px",
  },
  brandText: {
    fontFamily: `'"${BMWHelvetica75}"'`,
    fontWeight: 700,
    fontSize: "24px",
  },

  formContainer: {
    backgroundColor: "#FFFFFF",
    borderRadius: "20px",
    width: "340px",
    border: "none",
  },
  inputBox: {
    background: "#FFFFFF",
    boxShadow: "0px 0px 40px rgba(0, 0, 0, 0.1)",
    borderRadius: "24px",
    border: "none",
    paddingLeft: "18px",
    width: "340px",
    height: "49px",
    fontFamily: "Work Sans",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "18px",
    lineHeight: "21px",
    color: "#14142B",
  },
  buttonContainer: {
    width: "340px",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-end",
    marginTop: "20px",
  },
  wrapper: {
    margin: "1px",
    position: "relative",
  },
  buttonProgress: {
    color: "#053742",
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
  globalError: {
    display: "flex",
    flexDirection: "row",
    marginBottom: "30px",
    borderTop: "2px  solid #DB3939",
    borderRadius: "24px",
    padding: "12px 20px",
    width: "340px",
    height: "49px",
  },
  termsAndConditionLink: {
    fontFamily: "Work Sans",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "22px",
    color: "#39A2DB",
    marginTop: "18px",
    cursor: "pointer",
  },
  forgetText: {
    font: "14px Work Sans",
    lineHeight: "30px",
    color: "#39A2DB",
    textDecoration: "none !important",
    maxHeight: "30px !important",
    paddingLeft: "5px !important",
    cursor: "pointer",
    zIndex: 30,
  },
}));

/**
 * This file needs help. It looks like it's actually used (resident registration?). But it also looks duplicative.
 * @param props 
 * @returns 
 */
export default function UserLogin(props: RouteComponentProps<{}, StaticContext, LocationState>): ReactElement {
  const { location } = props;
  const navigation = useHistory();
  const dispatch = useDispatch();
  const { accountActivationDetails, isFetching, isSuccess, errorMessage, ipaUser, isAddProfileSuccess, isAddingProfile } = useSelector(selectAuthState);

  const classes = useStyles();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailError, setEmailError] = useState("");
  const [passError, setPassError] = useState("");
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [token, setToken] = useState("");
  const [residentUuid, setResidentUuid] = useState("");
  const [globalError, setGlobalError] = useState("");

  useEffect(() => {
    setEmail(location.state.email ||accountActivationDetails?.Email ||'')
    // if (accountActivationDetails) {
    //   setEmail(accountActivationDetails?.Email ? accountActivationDetails?.Email : "");
    // }
  }, [accountActivationDetails]);

  const validateEmail = () => {
    if (email.length === 0) {
      setEmailError("Email address is empty!");
      return false;
    } else if (!EmailRegex.test(email.trim())) {
      setEmailError("Invalid email address!");
      return false;
    }
    setEmailError("");
    return true;
  };
  const validatePassword = () => {
    if (password.length === 0) {
      setPassError("Password is empty!");
      return false;
    }
    setPassError("");
    return true;
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);

    if (validateEmail() && validatePassword()) {
      dispatch({
        type: getPasswordLogin.type,
        payload: {
          email: (data.get("email") as string).trim(),
          password: data.get("password"),
        },
      });
      return;
    }
  };

  useEffect(() => {
    if (emailError.length === 0 && passError.length === 0 && email.length !== 0 && password.length !== 0) setDisableSubmit(false);
  }, [emailError, passError, email, password, disableSubmit]);

  useEffect(() => {
    if (Object.keys(location.state).length !== 0) {
      setToken(location.state.token);
      
      if (location.state.residentUuid) {//This is for new resident registraion flow
        setResidentUuid(location.state.residentUuid);
      }
    }
  }, [token, location.state]);

  useEffect(() => {
    if (isFetching) setDisableSubmit(true);
  }, [isFetching, disableSubmit]);

  useEffect(() => {
    if (isSuccess) {
      dispatch({
        type: getAddProfile.type,
        payload: {
          ActivationToken: token,
        } as AddProfileDto,
      });
    }
  }, [dispatch, isSuccess]);

  useEffect(() => {
    if (isAddProfileSuccess) {
      //if mustChangePassword go to change password page
      if (ipaUser?.mustChangePassword) {
        navigation.push({
          pathname: "/changepassword",
          state: {
            mustChangePassword: true,
            username: ipaUser?.username,
            oldPassword: password,
          },
        })

        dispatch(clearCredentials());//clear login session
      } else {
        const principal = ipaUser?.profiles.find((p) => p.uuid === ipaUser.currentProfile.uuid);

        if (principal?.role === Role.PropertyManagerAdmin || principal?.role === Role.PropertyManager) {//determine which role this user is:
          //TODO: send them to the pm dashboard
          navigation.push("/pmui/transactions");
        } else if (principal?.role === Role.Resident) {
          //send them to the resui page
          dispatch(getResidentDetails());
          navigation.push({
            pathname: "/resui/payments",
            state: {
              addprofile: true,
            },
          });
        }
        else if (principal?.role === Role.Owner){
          navigation.push("/ownerui");
        }
      }
    }
  }, [isAddProfileSuccess, dispatch]);

  const matches900 = useMediaQuery("(max-width:900px)");
  const matches1200 = useMediaQuery("(max-width:1200px)");

  useEffect(() => {
    dispatch(getRefreshUser());
  }, [dispatch]);

  useEffect(() => {
    if (errorMessage) {
      setGlobalError(errorMessage);
    }
  }, [errorMessage]);

  return (
    <div className={classes.rootContainer}>
      <Grid sx={{ flexDirection: "column" }} className={classes.leftContainer}>
        <div className={classes.leftContainer}>
          {globalError && (
            <div className={classes.globalError}>
              <Typography
                style={{
                  fontFamily: "BMWHelvetica",
                  fontStyle: "normal",
                  fontWeight: 500,
                  fontSize: "14px",
                  lineHeight: "18px",
                  color: "#DB3939",
                }}
              >
                {" "}
                {globalError}
              </Typography>
            </div>
          )}

          <div className={classes.brandContainer}>
            <div>
              <img src={WhiteInosio} style={{ width: "130px", height: "130px" }} alt="logo" />
            </div>
            <div className={classes.brandtextContainer}>
              <Typography sx={{ fontFamily: "BMWHelveticaBold", fontWeight: "700", fontSize: "24px", fontStyle: "normal", lineHeight: "30px", color: "#14142B" }}>
                Welcome to
                <br /> {accountActivationDetails && Object.keys(accountActivationDetails).length !== 0 ? accountActivationDetails?.CompanyDbaName : ""}
              </Typography>
            </div>
          </div>
          <Grid container sx={{ display: "flex", justifyContent: "center", height: "48px", width: "380px", mb: "48px" }}>
            <Grid item xs={10}>
              <Typography
                align="center"
                sx={{
                  fontWeight: 400,
                  fontSize: "14px",
                  lineHeight: "16.4px",
                  fontFamily: "Work Sans",
                }}
                p={1}
              >
                Please enter your password in order to log in and connect this new account to your user profile.
              </Typography>
            </Grid>
          </Grid>
          <Box component="form" onSubmit={handleSubmit} noValidate className={classes.formContainer}>
            <div>
              <input
                required
                id="email"
                name="email"
                value={email}
                autoComplete="email"
                className={classes.inputBox}
                placeholder="Email address"
                onChange={(e) => setEmail(e.target.value)}
                //onBlur={validateEmail}
                style={{
                  borderTop: emailError.length ? "2px  solid #DB3939" : "none",
                  marginBottom: emailError.length ? "10px" : "15px",
                }}
              />
              {emailError.length ? (
                <Typography
                  style={{
                    fontFamily: "Work Sans",
                    paddingLeft: "18px",
                    fontStyle: "normal",
                    fontWeight: 400,
                    fontSize: "12px",
                    lineHeight: "22px",
                    color: "#DB3939",
                    marginBottom: "10px",
                  }}
                >
                  {emailError}
                </Typography>
              ) : (
                ""
              )}
            </div>
            <div>
              <input
                required
                id="password"
                name="password"
                autoComplete="password"
                type="password"
                placeholder="password"
                className={classes.inputBox}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                // onBlur={validatePassword}
                style={{
                  borderTop: passError.length ? "2px  solid #DB3939" : "none",
                  marginBottom: passError.length ? "10px" : "15px",
                }}
              />
              {passError.length ? (
                <Typography
                  style={{
                    fontFamily: "Work Sans",
                    paddingLeft: "18px",
                    fontStyle: "normal",
                    fontWeight: 400,
                    fontSize: "12px",
                    lineHeight: "22px",
                    color: "#DB3939",
                    marginBottom: "10px",
                  }}
                >
                  {passError}
                </Typography>
              ) : (
                ""
              )}
            </div>
            <div className={classes.buttonContainer}>
              <div className={classes.wrapper}>
                <Button
                  disabled={disableSubmit || isFetching || isAddingProfile}
                  type="submit"
                  variant="contained"
                  style={{
                    width: "113px",
                    height: "49px",
                    borderRadius: "24px",
                    textTransform: "capitalize",
                    color: "white",
                    backgroundColor: "#39A2DB",
                    borderColor: "#39A2DB",
                  }}
                >
                  Sign In
                </Button>
                {isFetching || isAddingProfile ? <CircularProgress size={26} className={classes.buttonProgress} /> : <></>}
              </div>
            </div>
          </Box>
          <Grid item sx={{ width: "340px" }} ml={2} mt={4}>
            <Divider style={{ width: "100%" }} />
          </Grid>
          <Grid item sx={{ display: "flex", flexDirection: "column", alignItems: "center", mt: "24px", mb: "24px", width: "340px" }}>
            <RouterLink
              to={{
                pathname: "/completeregistration",
                state: {
                  token,
                  residentUuid,
                },
              }}
              className={classes.forgetText}
            >
              Want to use a different email address ?
            </RouterLink>
            <Link component={RouterLink} to="/forgetpassword" className={classes.forgetText}>
              Forgot Password ?
            </Link>
          </Grid>
        </div>
      </Grid>

      {!(matches900 && matches1200) ? (
        <Grid className={classes.rightContainer}>
          <RightContainer />
        </Grid>
      ) : (
        <></>
      )}
    </div>
  );
}
